import React from 'react';
import StyledSlider from "../Slider/StyledSlider";
import type {AdjustValueType} from "./Calculator";
import {AdjustValue} from "./AdjustValue";
import {useTranslation} from "react-i18next";

interface DynamicActivityProps {
  distance: number;
  time: number;
  setDistance: (value: number) => void;
  setTime: (value: number) => void;
  adjustValue: AdjustValueType;
}

const DynamicActivity: React.FC<DynamicActivityProps> = ({ distance, setDistance, time, setTime, adjustValue }) => {

  const { t } = useTranslation();

  const [distanceInput, setDistanceInput] = React.useState(distance.toString());
  const [timeInput, setTimeInput] = React.useState(time.toString());

  React.useEffect(() => {
    setDistanceInput(distance.toString());
  }, [distance]);

  React.useEffect(() => {
    setTimeInput(time.toString());
  }, [time]);

  return (
    <div>
      <h3>{t('dynamic.title')}</h3>

      <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
        <div>

          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <label style={{display: 'flex', alignItems: 'center', gap: '0.5rem', padding: "20px 0"}}>
              {t('dynamic.distance')}:
              <input
                type="number"
                value={distanceInput}
                onChange={(e) => setDistanceInput(e.target.value)}
                onBlur={() => {
                  const parsed = Number(distanceInput);
                  if (!isNaN(parsed)) {
                    const clamped = Math.min(Math.max(parsed, 0), 30);
                    setDistance(clamped);
                  }
                }}
                step={0.1}
                style={{
                  width: '54px',
                  padding: '0.25rem 0 0.25rem 0.25rem',
                  fontSize: '20px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                }}
              />
              {t('unit.km')}
            </label>
            <AdjustValue adjust={adjustValue.bind(null, 'distance')}/>
          </div>
          <StyledSlider
            value={distance}
            onChange={setDistance}
            min={1}
            max={30}
            values={[1, 5, 10, 15, 20, 25, 30]}
            step={0.1}
            unit={t('unit.km')}
          />
        </div>
        <div>

          <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <label style={{display: 'flex', alignItems: 'center', gap: '0.5rem', padding: "20px 0"}}>{t('duration')}:
            <input
              type="number"
              value={timeInput}
              onChange={(e) => setTimeInput(e.target.value)}
              onBlur={() => {
                const parsed = Number(timeInput);
                if (!isNaN(parsed)) {
                  const clamped = Math.min(Math.max(parsed, 1), 270);
                  setTime(clamped);
                }
              }}
              step={1}
              style={{
                width: '54px',
                padding: '0.25rem 0 0.25rem 0.25rem',
                fontSize: '20px',
                borderRadius: '4px',
                border: '1px solid #ccc'
              }}
            /> {t('unit.minutes')}</label>
          <AdjustValue adjust={adjustValue.bind(null, 'time')}/>
        </div>

        <StyledSlider
          value={time}
          onChange={setTime}
          min={1}
          max={270}
          step={1}
          values={[1, 30, 60, 90, 120, 150, 180, 210, 240, 270]}
          unit={t('unit.minutes')}
        />
      </div>
    </div>
</div>
)
  ;
};

export default DynamicActivity;